/**
 * Portfolio 开弹窗前选图 · 统一入口（策略分发）
 *
 * 调用方：`openPortfolioScreenshotModal`（`pickOnOpen: true` 时）。
 * 返回 `null` 表示用户取消；非 null 则作为 `initialFiles` 传入弹窗。
 *
 * 分端实现：
 * - `pickPortfolioFiles.ios.ts`   — detached + focus（真机金标准，勿改走 session）
 * - `pickPortfolioFiles.android.ts` — Host + session
 * - `pickPortfolioFiles.web.ts`   — detached + focus
 *
 * @see apps/token-seek/features/20260610-portfolio-file-pick-platform-strategy/SPEC.md
 */
import type { PortfolioUploadType } from "@components/PortfolioScreenshotModal/types";
import { pickPortfolioFilesOnAndroid } from "./strategies/pickPortfolioFiles.android";
import { pickPortfolioFilesOnIos } from "./strategies/pickPortfolioFiles.ios";
import { resolvePortfolioFilePickStrategy } from "./shared/portfolioFilePickStrategy";
import { pickPortfolioFilesOnWeb } from "./strategies/pickPortfolioFiles.web";

/**
 * 打开系统文件选择器（image / pdf），按当前平台策略执行。
 * @returns 选中文件列表；用户取消或未选文件时返回 `null`
 */
export async function pickPortfolioFiles(
  uploadType: PortfolioUploadType = "image",
): Promise<File[] | null> {
  const strategy = resolvePortfolioFilePickStrategy();

  if (strategy === "android") {
    return pickPortfolioFilesOnAndroid(uploadType);
  }
  if (strategy === "ios") {
    return pickPortfolioFilesOnIos(uploadType);
  }
  return pickPortfolioFilesOnWeb(uploadType);
}
